import SupplierSpecificTermsDefault from "./Default";
import SupplierSpecificTermsEdf from "./Edf";
import SupplierSpecificTermsEon from "./Eon";
import SupplierSpecificTermsEonNext from "./EonNext";
import SupplierSpecificTermsShellEnergy from "./ShellEnergy";
import SupplierSpecificTermsOvo from "./Ovo";
import SupplierSpecificTermsUtilita from "./Utilita";
import SupplierSpecificTermsPfpEnergy from "./PfpEnergy";
import SupplierSpecificTermsOctopusEnergy from "./OctopusEnergy";
import SupplierSpecificTermsSimplicity from "./Simplicity";
import SupplierSpecificTermsAes from "./AES";
import SupplierSpecificTermsSoEnergy from "./SoEnergy";
import SupplierSpecificTermsRebelEnergy from "./RebelEnergy";

export default {
  SupplierSpecificTermsDefault,
  SupplierSpecificTermsEdf,
  SupplierSpecificTermsEon,
  SupplierSpecificTermsEonNext,
  SupplierSpecificTermsShellEnergy,
  SupplierSpecificTermsOvo,
  SupplierSpecificTermsUtilita,
  SupplierSpecificTermsPfpEnergy,
  SupplierSpecificTermsOctopusEnergy,
  SupplierSpecificTermsSimplicity,
  SupplierSpecificTermsAes,
  SupplierSpecificTermsSoEnergy,
  SupplierSpecificTermsRebelEnergy
};
